import { paths } from "@securityjourney/svc-learner-ai/dist/gen/sj_admin";

import { OpenApiFetchWrapper } from "../openApiFetchWrapper";

export class ChatClient extends OpenApiFetchWrapper<paths> {
  async getCapabilities(tenant: string) {
    return await this.get("/svc/learner-ai/{tenant}/chat/capabilities", {
      params: { path: { tenant } },
    });
  }
}

let chatClientInstance: ChatClient | null = null;

export const getChatClient = (): ChatClient => {
  if (!chatClientInstance) {
    chatClientInstance = new ChatClient();
  }
  return chatClientInstance;
};
